/** @flow */
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import IncreaseDecreasePercent from 'common/components/IncreaseDecreasePercent';
import { Numeric } from 'common/components/Number';

const defaultIconSize = 30;

const Wrapper = styled.div`
  display: flex;
  flex-flow: row;
  padding: ${({ theme }) => theme.metrics.margin}px;

  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Row = styled.div`
  text-align: center;
  padding: 0 ${({ theme }) => theme.metrics.tinyMargin}px;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: ${({ theme }) => theme.fonts.style.midSmall.fontSize}px;
  margin-bottom: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const NA = styled.div`
  color: ${({ theme }) => theme.fonts.style.main.color};
  font-size: ${({ theme }) => theme.fonts.style.main.fontSize};
`;

const ComparedWrapper = styled.div`
  position: absolute;
  width: 100%;
  transform: translate(100%);
`;

const ComparedRow = styled.div`
  position: absolute;
  font-size: ${({ theme }) => theme.fonts.style.small.fontSize}px;
  white-space: nowrap;
`;

const MetricNumber = styled(Numeric)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fonts.style.main.fontSize}px;
`;

const MetricSuffix = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fonts.style.sub.fontSize}px;
`;

type Data = number | { current: number; compared: number };

type Props = {
  title: string;
  value?: Data;
  roundAt?: number;
  suffix?: string;
  converter?: (number) => number;
  textStyle?: Object,
  wrapperStyle?: Object,
  iconSize: ?number;

  t: any;
  theme: any,
  className: string;
};

function Compared(props: { current: number; compared: number; theme: any; iconSize: ?number; }) {
  const { current, compared, theme } = props;
  const color = current > compared ? theme.colors.increaseStats : theme.colors.decreaseStats;
  const delta = current - compared;
  const iconSize = props.iconSize ? props.iconSize : defaultIconSize;

  return (
    <ComparedWrapper>
      <ComparedRow style={{ color }}>
        <IncreaseDecreasePercent
          percent={(delta / compared)}
          style={{ ...theme.fonts.style.sub, justifyContent: 'start' }}
          iconSize={{ width: iconSize, height: iconSize }}
        />
      </ComparedRow>
    </ComparedWrapper>
  );
}

function SingleMetric(props: Props) {
  const { value, t, theme, textStyle, wrapperStyle, iconSize, className } = props;

  const renderMetric = (data: Data) => {
    const converter = props.converter || (n => n);
    const roundAt = props.roundAt || 0;

    const current = converter(typeof data === 'number' ? data : data.current);
    const compared = typeof data === 'number' ? undefined : converter(data.compared);

    return (
      <div>
        <Row style={{ position: 'relative', display: 'inline-block' }}>
          {compared && <Compared current={current} compared={compared} theme={theme} iconSize={iconSize} />}
          <div>
            <MetricNumber value={current} roundAt={roundAt} style={textStyle} />
            {props.suffix && <MetricSuffix> {props.suffix}</MetricSuffix>}
          </div>
        </Row>
      </div>
    );
  };

  if (value === null || value === undefined) {
    return (
      <Wrapper style={wrapperStyle} className={className}>
        <Row>
          <Title>{props.title}</Title>
          <NA>{t('na')}</NA>
        </Row>
      </Wrapper>
    );
  }

  return (
    <Wrapper style={wrapperStyle} className={className}>
      <Row>
        <Title>{props.title}</Title>
        {renderMetric(value)}
      </Row>
    </Wrapper>
  );
}

export default translate()(withTheme(SingleMetric));



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/components/SingleMetric.js